export default __webpack_public_path__ + "7715b4cf87ad7dace94a71bb9db6dd4b.svg";